export enum Entities {
    CUSTOMER, MEAL, CUSTOMERMEAL, MEALDATE
}